import QRCode from 'qrcode';
import { formatQrPayload } from '@chariot/contract';

/**
 * QR images are generated as SVG, not canvas PNG: labels are printed, and vector output
 * stays crisp at any size on any printer instead of being resampled.
 */
export async function qrSvg(code: string): Promise<string> {
  return QRCode.toString(formatQrPayload(code), {
    type: 'svg',
    errorCorrectionLevel: 'M',
    margin: 0,
    // Rendered into a sized container by CSS; the intrinsic width is irrelevant.
    width: 256,
  });
}

export async function qrDataUrl(code: string): Promise<string> {
  return QRCode.toDataURL(formatQrPayload(code), {
    errorCorrectionLevel: 'M',
    margin: 1,
    width: 512,
  });
}
